import { createContext, useEffect, useReducer } from "react"
import LoginReducer from "./loginReducer";
import { jwtDecode } from "jwt-decode";


const INITIAL_STATE = {
    user: JSON.parse(localStorage.getItem("user")) || null,
    isFetching: false,
    error: false
}


export const Context = createContext(INITIAL_STATE);

export const ContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(LoginReducer, INITIAL_STATE);
    useEffect(() => {
        localStorage.setItem("user", JSON.stringify(state.user));

    }, [state.user])

    // 🔥 Check Token Expiry Automatically
    useEffect(() => {
        if (state.user?.token) {
            const decoded = jwtDecode(state.user.token);
            // console.log({decoded});
            
            const currentTime = Date.now() / 1000;

            if (decoded.exp < currentTime) {
                // Token expired
                localStorage.clear();
                dispatch({ type: "LOGOUT" });
                window.location.href = "/login";
            }
        }
    }, [state.user]);


    return (
        <Context.Provider value={{
            user: state.user,
            isFetching: state.isFetching,
            error: state.error,
            dispatch,
        }}>
            {children}
        </Context.Provider>
    )
}
export default ContextProvider